import {PaymentMethodController} from "./PaymentMethodController.js";
import {SubscriptionPlanController} from "./SubscriptionPlanController.js";
import {AddressController} from "./AddressController.js";


// These are instantiated in the flow state classes and throughout the inline user dashboard
export const Controller = {
    paymentMethod: new PaymentMethodController(),
    subscriptionPlan: new SubscriptionPlanController(),
    address: new AddressController(),
}
